exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-add-field {\n  font-weight: bold;\n  background-color: #3B8686;\n  color: #fff;\n  align-self: flex-end;\n}", ""]);

// exports
